import { render } from "./TheLanguageSwitch.vue?vue&type=template&id=24462199"
import script from "./TheLanguageSwitch.vue?vue&type=script&lang=js"
export * from "./TheLanguageSwitch.vue?vue&type=script&lang=js"

import "./TheLanguageSwitch.vue?vue&type=style&index=0&id=24462199&lang=scss"

import exportComponent from "/Users/hirosuke-pi/projects/vr-jmof-front-2020/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__